var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" " + _vm._s(_vm.entityName) + " "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: {
                      "tooltip is-tooltip-danger is-tooltip-right":
                        _vm.$v.detailGroup.$error,
                    },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.InsurerDetail.name,
                        params: { insurerId: _vm.$route.params.insurerId },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      "data-tooltip": [
                        _vm.$v.detailGroup.$error ? "Validation errors" : "",
                      ],
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.detailGroup.$error,
                        },
                        attrs: { "data-badge": null },
                      },
                      [_vm._v(" Detail Info ")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.InsurerRatesMarkups.name,
                        params: { insurerId: _vm.$route.params.insurerId },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [_vm._v("Rates & Markups ")]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: {
                      "tooltip is-tooltip-danger is-tooltip-right":
                        _vm.$v.addressesGroup.$error,
                    },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.InsurerAddress.name,
                        params: { insurerId: _vm.$route.params.insurerId },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      "data-tooltip": [
                        _vm.$v.addressesGroup.$error ? "Validation errors" : "",
                      ],
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.addressesGroup.$error,
                        },
                        attrs: {
                          "data-badge": _vm.$v.addressesGroup.$error
                            ? ""
                            : null,
                        },
                      },
                      [_vm._v(" Addresses ")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: {
                      "tooltip is-tooltip-danger is-tooltip-right":
                        _vm.$v.emailsPhonesGroup.$error,
                    },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.InsurerPhoneEmail.name,
                        params: { insurerId: _vm.$route.params.insurerId },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      "data-tooltip": [
                        _vm.$v.emailsPhonesGroup.$error
                          ? "Validation errors"
                          : "",
                      ],
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.emailsPhonesGroup.$error,
                        },
                        attrs: {
                          "data-badge": _vm.$v.emailsPhonesGroup.$error
                            ? ""
                            : null,
                        },
                      },
                      [_vm._v(" Phones/Emails ")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: {
                      "tooltip is-tooltip-danger is-tooltip-right":
                        _vm.$v.contactsGroup.$error,
                    },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.InsurerContacts.name,
                        params: { insurerId: _vm.$route.params.insurerId },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      "data-tooltip": [
                        _vm.$v.contactsGroup.$error ? "Validation errors" : "",
                      ],
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.contactsGroup.$error,
                        },
                        attrs: {
                          "data-badge": _vm.$v.contactsGroup.$error ? "" : null,
                        },
                      },
                      [_vm._v(" Contacts ")]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm.isNtar
            ? _c("p", { staticClass: "menu-label" }, [_vm._v(" NTAR ")])
            : _vm._e(),
          _vm.isNtar
            ? _c("ul", { staticClass: "menu-list" }, [
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        class: {
                          "tooltip is-tooltip-danger is-tooltip-right":
                            _vm.isError.CMI,
                        },
                        attrs: {
                          to: {
                            name: _vm.routeTypes.InsurerConsumables.name,
                            params: { insurerId: _vm.$route.params.insurerId },
                            query: _vm.$route.query,
                          },
                          "active-class": "is-active",
                          "data-tooltip": [
                            _vm.isError.CMI ? "Validation errors" : "",
                          ],
                          exact: "",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                _vm.isError.CMI,
                            },
                            attrs: {
                              "data-badge": _vm.isError.CMI ? "" : null,
                            },
                          },
                          [_vm._v(" Consumables ")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        class: {
                          "tooltip is-tooltip-danger is-tooltip-right":
                            _vm.isError.LVI,
                        },
                        attrs: {
                          to: {
                            name: _vm.routeTypes.InsurerLoadingValues.name,
                            params: { insurerId: _vm.$route.params.insurerId },
                            query: _vm.$route.query,
                          },
                          "active-class": "is-active",
                          "data-tooltip": [
                            _vm.isError.LVI ? "Validation errors" : "",
                          ],
                          exact: "",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                _vm.isError.LVI,
                            },
                            attrs: {
                              "data-badge": _vm.isError.LVI ? "" : null,
                            },
                          },
                          [_vm._v(" Loading Values ")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        class: {
                          "tooltip is-tooltip-danger is-tooltip-right":
                            _vm.isError.PMI,
                        },
                        attrs: {
                          to: {
                            name: _vm.routeTypes.InsurerPaintMaterials.name,
                            params: { insurerId: _vm.$route.params.insurerId },
                            query: _vm.$route.query,
                          },
                          "active-class": "is-active",
                          "data-tooltip": [
                            _vm.isError.PMI ? "Validation errors" : "",
                          ],
                          exact: "",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                _vm.isError.PMI,
                            },
                            attrs: {
                              "data-badge": _vm.isError.PMI ? "" : null,
                            },
                          },
                          [_vm._v(" Paint Materials ")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        class: {
                          "tooltip is-tooltip-danger is-tooltip-right":
                            _vm.isError.SPI,
                        },
                        attrs: {
                          to: {
                            name: _vm.routeTypes.InsurerSpecialRates.name,
                            params: { insurerId: _vm.$route.params.insurerId },
                            query: _vm.$route.query,
                          },
                          "active-class": "is-active",
                          "data-tooltip": [
                            _vm.isError.SPI ? "Validation errors" : "",
                          ],
                          exact: "",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                _vm.isError.SPI,
                            },
                            attrs: {
                              "data-badge": _vm.isError.SPI ? "" : null,
                            },
                          },
                          [_vm._v(" Special Rates ")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("p", { staticClass: "menu-label" }, [_vm._v(" Others ")]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.InsurerAutoItems.name,
                        params: { insurerId: _vm.$route.params.insurerId },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [_vm._v("Auto Items ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }